import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import history from '../../../routes/history';
import { fetchVoicebotInstances } from '../../../store/actions/voice-bots';

import { Container } from './styles';

const BoxNewBot = ({ handleCreateChatBot }) => {
  const { signedUser } = useSelector((state) => state.users);
  const { voicebotInstances } = useSelector((state) => state.voiceBot);

  const dispatch = useDispatch();

  useEffect(() => {
    if (signedUser?.selectedOrganization) {
      const { selectedOrganization } = signedUser;
      dispatch(
        fetchVoicebotInstances({ organizationId: selectedOrganization })
      );
    }
  }, [signedUser]);

  const hasVoicebotSettings = useMemo(() => {
    if (!signedUser?.codeUser) return false;

    if (!voicebotInstances.length) return false;

    return true;
  }, [signedUser, voicebotInstances]);

  return (
    <Container className="box-iniciar" key="new">
      <img alt="" src="assets/images/icons/icon_novobot.svg" />

      <div className="new-bot__wrapper-menu">
        <h3 className="new-bot__title">Criar novo bot</h3>

        <button
          type="button"
          className="new-bot__button new-bot__button--orange"
          onClick={handleCreateChatBot}
        >
          Chatbot em branco
        </button>

        <button
          type="button"
          className="new-bot__button new-bot__button--orange"
          onClick={() => history.push('/novo-bot')}
        >
          Template de Chatbot
        </button>

        {hasVoicebotSettings && (
          <button
            type="button"
            className="new-bot__button new-bot__button--blue"
            onClick={() => history.push('/novo-voicebot')}
          >
            Voicebot
          </button>
        )}
      </div>
    </Container>
  );
};

export default BoxNewBot;
